import { cards } from '@/mocks/chiguaData';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8 md:mb-10">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100">
              <i className="ri-article-line text-xl text-secondary-700"></i>
            </div>
            <div>
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
                热门瓜文
              </h2>
              <p className="text-sm text-foreground-500 mt-0.5">深度吃瓜，一文读懂</p>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cards.map((card) => (
            <div
              key={card.id}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-colors cursor-pointer"
            >
              <div className="relative aspect-[3/2] overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-1 rounded text-xs font-medium bg-primary-500 text-white">
                    {card.category}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-1 text-xs text-foreground-400 mb-2">
                  <i className="ri-time-line"></i>
                  <span>{card.time}</span>
                </div>
                <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-2.5 leading-snug line-clamp-2">
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {card.summary}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}